import React from "react";
import PropTypes from "prop-types";
import styles from "../Banner.module.css";

const DoubleBannerWrapper = (props) => {
  const {  is_external_url, external_url, image_url, className, onClick } = props;
    if(is_external_url) {
        return (
            <div className={`${styles.HalfImageContainer} ${className}`}>
            <a href={external_url} className={styles.BannerLink}>
              <img
                className={styles.SingleImage}
                alt={"banner"}
                src={image_url}
              />
            </a>
          </div>
        )
    }
  return (
    <div
      onClick={onClick}
      className={`${styles.HalfImageContainer} ${className}`}
    >
      <img
        className={styles.SingleImage}
        alt={"banner"}
        src={image_url}
      />
    </div>
  );
};

DoubleBannerWrapper.propTypes = {
    is_external_url: PropTypes.bool,
    external_url: PropTypes.string,
    image_url: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func
}

export default DoubleBannerWrapper;
